import type { IntlShape } from 'react-intl'

const ONBOARD_CREDIT_DESCRIPTION_PATTERN = /^Up to (.+) Onboard Credit$/

function formatOfferInclusionDescription(description: string | undefined, intl: IntlShape): string {
  if (!description) return ''

  const onboardCreditMatch = description.match(ONBOARD_CREDIT_DESCRIPTION_PATTERN)
  if (!onboardCreditMatch?.[1]) {
    return description
  }

  return intl.formatMessage(
    {
      id: 'p2sftr3r_5GHL1rQi-MG',
      defaultMessage: 'Up to {amount} Onboard Credit',
    },
    {
      amount: onboardCreditMatch[1],
    },
  )
}

export default formatOfferInclusionDescription
